import React from 'react'

function ErrorPage() {
  return (
    <div className='errorPage'>
      error page
    </div>
  )
}

export default ErrorPage
